import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from '@omilia/tooltip';
import SHORTCUTS from 'constants/keyboardShortcutsMenu';

import { menuItemType } from 'types';
import './style.scss';

const MenuItem = ({
  item,
  isOpen,
  isTop,
  hasChildren,
  isExpanded,
  className,
  ...restProps
}) => {
  const key = SHORTCUTS[`go-to:${item.apptitle}`];

  /* eslint-disable jsx-a11y/anchor-is-valid */
  return (
    <Tooltip
      placement="right"
      content={
        <React.Fragment>
          {item.title} {key ? `( ${key} )` : ''}
        </React.Fragment>
      }
    >
      <div
        styleName={cn('menu__item', {
          'is-open': isOpen,
          'is-closed': !isOpen,
          'is-top': isTop,
          'has-children': hasChildren,
          'is-expanded': isExpanded,
        })}
        className={className}
        data-test={`item-${item.icon}`}
        {...restProps}
      >
        <span styleName="icon" className={`icon-${item.icon}`} />
        {isOpen && <span styleName="title">{item.title}</span>}
      </div>
    </Tooltip>
  );
};

MenuItem.propTypes = {
  isOpen: PropTypes.bool,
  hasChildren: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isTop: PropTypes.bool,
  item: menuItemType,
  className: PropTypes.string,
};

MenuItem.defaultProps = {
  isOpen: false,
  hasChildren: false,
  isExpanded: false,
  isTop: false,
  className: '',
};

export default MenuItem;
